define([
    'text!WebCommon/modal/fnji-weixin.html',
    'WebCommon/mixin/modal',

    'css!WebCommon/modal/fnji-weixin.css'
], function(
    tpl,
    ModalMixin
){
    return {
        template: tpl,
        mixins: [ModalMixin]
    };
});


//////////////////
// WEBPACK FOOTER
// ../common/modal/fnji-weixin.js
// module id = 48
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24